var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      this.currentStepName == "travellers"
        ? [
            _c("div", { staticClass: "price-breakdown" }, [
              _c(
                "table",
                { staticClass: "price-breakdown__table" },
                [
                  this.isDonationPerPassanger
                    ? _vm._l(_vm.completedRooms, function (room) {
                        return _c(
                          "tbody",
                          { staticClass: "donation-block" },
                          [
                            room == _vm.completedRooms[0]
                              ? _c("tr", [
                                  _c("th", { attrs: { colspan: "2" } }, [
                                    _vm._v(
                                      "You are turning travel into impact with a Planeterra donation"
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            room == _vm.completedRooms[0]
                              ? _c("tr", [
                                  _c("td", [
                                    _c("small", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.data.donations.label
                                        ),
                                      },
                                    }),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(room.passengers, function (passenger) {
                              return _c("tr", [
                                _vm.getPassengerName(passenger) != ""
                                  ? _c("td", { attrs: { align: "left" } }, [
                                      _c("input", {
                                        class: {
                                          checkbox_ts:
                                            _vm.data.brandNameFormatted ===
                                            _vm.Brand.Travelsphere,
                                        },
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked:
                                            _vm.didPassangerDonate(passenger),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.travellerDonate(
                                              passenger
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getPassengerName(passenger)
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.getPassengerName(passenger) != "" &&
                                !passenger.donated
                                  ? _c("td", { attrs: { align: "right" } }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.currency(
                                              _vm.donationsData.price
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            }),
                          ],
                          2
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.isDonationPerBooking
                    ? [
                        _c("tbody", [
                          _vm._m(0),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", { attrs: { align: "left" } }, [
                              _c("input", {
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: _vm.donatedForEntireBooking(),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.bookingDonate()
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(this.donationData.name)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.currency(_vm.donationsData.price)
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "price-breakdown-wrapper" }, [
        _c("div", { staticClass: "price-breakdown" }, [
          _c("h2", { staticClass: "price-breakdown__title" }, [
            _vm._v("Price Breakdown"),
          ]),
          _vm._v(" "),
          _vm.subtotalMismatch
            ? _c("div", { staticClass: "error-message error-message--grey" }, [
                _c("div", { staticClass: "error-message__icon" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "error-message__text",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.data.priceBreakdown.subtotalMismatchHtml
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "price-breakdown__table" },
            [
              _c("tbody", [
                _vm._m(2),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { attrs: { colspan: "2" } }, [
                    _vm._v(_vm._s(_vm.data.tourName)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  !_vm.departureDetails.departureLegs.length
                    ? _c("td", { attrs: { colspan: "2" } }, [
                        _vm._v(
                          "From " +
                            _vm._s(
                              _vm.departureDetails.departureNoFlights.location
                            ) +
                            " on " +
                            _vm._s(_vm.departureDetails.departureNoFlights.date)
                        ),
                      ])
                    : _c("td", { attrs: { colspan: "2" } }, [
                        _vm._v(
                          "From " +
                            _vm._s(
                              _vm.departureDetails.departureLegs[0]
                                .departureAirport.name
                            ) +
                            " on " +
                            _vm._s(
                              _vm.departureDetails.departureLegs[0]
                                .departureTime.date
                            )
                        ),
                      ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.completedRooms, function (room) {
                return _c(
                  "tbody",
                  { key: room.key },
                  [
                    _c("tr", [
                      _c("th", { attrs: { colspan: "2" } }, [
                        _vm._v("Room type: " + _vm._s(room.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(room.passengers, function (passenger) {
                      return _c("tr", { key: passenger.key }, [
                        _c("td", [
                          _vm._v(_vm._s(_vm.getPassengerName(passenger))),
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { align: "right" } }, [
                          !_vm.subtotalMismatch
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currency(room.pricePerPerson))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              this.currentStepName == "travellers"
                ? [
                    this.isDonationPerPassanger
                      ? [
                          _c(
                            "tbody",
                            [
                              _vm.anyPassangerDonated
                                ? [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _vm._l(_vm.completedRooms, function (room) {
                                      return _vm._l(
                                        room.passengers,
                                        function (passenger) {
                                          return _vm.didPassangerDonate(
                                            passenger
                                          )
                                            ? _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { align: "left" } },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getPassengerName(
                                                            passenger
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.currency(
                                                            _vm.donationsData
                                                              .price
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      )
                                    }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    this.isDonationPerBooking
                      ? [
                          _c("tbody", [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { attrs: { align: "left" } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.donationData.name)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { align: "right" } }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.currency(_vm.donationsData.price)
                                    ) +
                                    "\n                  "
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              this.currentStepName != "travellers" &&
              _vm.passangersWhoDonated.length > 0
                ? [
                    _c(
                      "tbody",
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _vm._l(_vm.passangersWhoDonated, function (passenger) {
                          return _c("tr", [
                            _c("td", { attrs: { align: "left" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDonatingPassengerName(passenger)
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.currency(_vm.donationsData.price)
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              this.currentStepName != "travellers" && _vm.isDonationPerBooking
                ? [
                    _c("tbody", [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { attrs: { align: "left" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.donationData.name))]),
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.currency(_vm.donationsData.price)) +
                              "\n                "
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.completedExcursions.length
                ? _c(
                    "tbody",
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _vm._l(_vm.completedExcursions, function (excursion) {
                        return _c("tr", { key: excursion.id }, [
                          _c("td", [_vm._v(_vm._s(excursion.name))]),
                          _vm._v(" "),
                          _c("td", { attrs: { align: "right" } }, [
                            !_vm.subtotalMismatch
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      excursion.passengers.filter(
                                        (passenger) => passenger.selected
                                      ).length
                                    ) +
                                      " × " +
                                      _vm._s(_vm.currency(excursion.price))
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedVisas.length
                ? _c(
                    "tbody",
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _vm._l(_vm.selectedVisas, function (visa) {
                        return _c("tr", { key: visa.id }, [
                          _c("td", [_vm._v(_vm._s(visa.name))]),
                          _vm._v(" "),
                          _c("td", { attrs: { align: "right" } }, [
                            !_vm.subtotalMismatch
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(visa.count) +
                                      " × " +
                                      _vm._s(_vm.currency(visa.price))
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.subtotal && this.currentStepName != "travellers"
          ? _c("div", { staticClass: "subtotal-placeholder" }, [
              _c("div", { staticClass: "subtotal subtotal--sticky" }, [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "subtotal-inner" }, [
                    _c("div", { staticClass: "subtotal-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "subtotal__text",
                          class: {
                            subtotal__text__colorTs:
                              _vm.data.brandNameFormatted ===
                              _vm.Brand.Travelsphere,
                          },
                        },
                        [_vm._v("Subtotal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "subtotal__cost",
                          class: {
                            subtotal__text__colorTs:
                              _vm.data.brandNameFormatted ===
                              _vm.Brand.Travelsphere,
                          },
                        },
                        [_vm._v(_vm._s(_vm.currency(_vm.subtotal)))]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.subtotal && this.currentStepName == "travellers"
          ? _c("div", [
              _c("div", { staticClass: "subtotal" }, [
                _c("div", { staticClass: "subtotal-inner" }, [
                  _c("div", { staticClass: "subtotal-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "subtotal__text",
                        class: {
                          subtotal__text__colorTs:
                            _vm.data.brandNameFormatted ===
                            _vm.Brand.Travelsphere,
                        },
                      },
                      [_vm._v("Subtotal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "subtotal__cost",
                        class: {
                          subtotal__text__colorTs:
                            _vm.data.brandNameFormatted ===
                            _vm.Brand.Travelsphere,
                        },
                      },
                      [_vm._v(_vm._s(_vm.currency(_vm.subtotal)))]
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [
        _vm._v("Turning travel into Impact - voluntary donation to Planeterra"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", [
        _c("small", [
          _vm._v(
            "If you do not wish to make this donation, please untick the box below"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [_vm._v("Holidays and Add-Ons")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [
        _vm._v("Turning travel into Impact - voluntary donation to Planeterra"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [
        _vm._v("You are turning travel into impact with a Planeterra donation"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [
        _vm._v("Turning travel into Impact - voluntary donation to Planeterra"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [
        _vm._v("You are turning travel into impact with a Planeterra donation"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [_vm._v("Optional Excursions")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [_vm._v("Optional Visas")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }